<template>
  <div id="fusion_contact_details_container" class="flex flex-col">
    <div class="h-full w-full">
      <div v-show="processing || error" class="text-center py-5">
        <div v-show="processing" class="fusion-loader loader-xl" />
        <span v-if="!processing && error">{{ error }}</span>
      </div>
      <iframe v-if="!processing && !error && contact_url" :src="contact_url" class="h-full w-full border-0" />
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useMainStore } from '@store/main';

export default {
  props: {
    setConfiguration: {
      type: Object,
      required: true,
      validator: function (value) {
        return Boolean(value && value.FuseConfigurations);
      }
    },
  },
  async created() {
    await this.getSettings();
    this.getContactUrlToken();
  },
  data() {
    return {
      contact_url_token: null,
      error: '',
      processing: false,
    }
  },
  computed: {
    ...mapStores(useMainStore),
    user_access_info() {
      return this.mainStore.user_access_info;
    },
    user_settings: {
      get() {
        return this.mainStore.user_settings;
      },
      set(value) {
        this.mainStore.user_settings = value;
      }
    },
    user_guid() {
      return this.user_access_info?.userId || null;
    },
    primary_cif() {
      return this.mainStore.current_cif || null;
    },
    fuse_configurations() {
      return this.setConfiguration?.FuseConfigurations || null;
    },
    contact_url() {
      let baseUrl = import.meta.env.VITE_GUBAGOO_API_BASE_URI;
      let jwtToken = this.contact_url_token;
      if(this.contact_url_token)
        return `${baseUrl}?_atoken=${jwtToken}`;
      
      return null;
    },
    cif() {
      return this.fuse_configurations?.cif || null;
    },
    contact_cdp_id() {
      return this.fuse_configurations?.cdpId || null;
    },
    contact_email() {
      return this.fuse_configurations?.email || null;
    },
    contact_phone() {
      return this.fuse_configurations?.phone || null;
    },
    settings_flat() {
      return this.user_settings?.flat || null;
    },
    settings_timezone() {
      return this.settings_flat?.['Time.Timezone'] || null;
    },
    settings_language() {
      return this.settings_flat?.['Ux.Language'] || null;
    },
    get_contact_url_token_dto() {
      return {
        cif: this.cif || this.primary_cif,
        timezone: this.settings_timezone,
        languages: this.settings_language,
        cdpid: this.contact_cdp_id,
        email: this.contact_email,
        phone: this.contact_phone,
      };
    },
  },
  methods: {
    async getSettings() {
      const self = this;
      if(this.user_settings)
        return;
      
      try {
        let getSettingsDTO = `tenantId=default-tenant&userId=${this.user_guid}`;
        const response = await self.mainStore.GetSettings(getSettingsDTO);
        self.user_settings = response && response.flat?response:null;
      }
      catch (error) {
      }
    },
    getContactUrlToken() {
      this.processing = true;
      const self = this;
      this.mainStore.GetContactUrlToken(this.get_contact_url_token_dto).then(response => {
        if(response && response.token)
          self.contact_url_token = response.token;
        else
          self.error = self.$t('messaging.contactDetails.errorLoading');
        
        self.processing = false;
      }, error => {
        self.error = self.$t('messaging.contactDetails.errorLoading');
        self.processing = false;
      });
    },
  },
  watch: {
    get_contact_url_token_dto: {
      handler(newVal, oldVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal))
          this.getContactUrlToken();
      },
      deep: true
    }
  },
}
</script>
